import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'send-mail',
  templateUrl: './send-mail.component.html',
  styleUrls: ['./send-mail.component.css','../../admin.css']
})
export class SendMailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/email/send-mail/send-mail.component.ts